var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ERentioFormField } from "@rentiohq/shared-frontend/dist/components/components/Form";
import { CONFIG } from "@rentiohq/shared-frontend/dist/config/app.config";
import { EField as EEpcField } from "@rentiohq/shared-frontend/dist/forms/epc/schema.epcInfo.types";
import { getValue } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { formatCurrency } from "@rentiohq/shared-frontend/dist/utils/number.utils";
import { ts } from "../../services";
import { EField } from "./schema.indexContract.types";
import { calculatePartiallyIndexedCost, canIndex, getActualTotal, getAdjustedRetroactiveAmountLabel, getDefaultTotal, getEpcBasedLimitationInfoSubtitle, getLegalTotalInfoSubtitle, getMaximumPrice, getNewAdditionalCostFieldsSchema, getNewAdditionalCostFieldsUiSchema, showEpcBasedLimitationInfoSubtitle, } from "./schema.indexContract.utils";
export var getSchema = function (extraData, initialValues) {
    return function (defaultValues) {
        var _a, _b;
        var _c;
        return {
            required: [EField.NewPrice],
            properties: __assign(__assign((_a = {}, _a[EField.EpcBasedLimitationInfo] = {
                default: undefined,
                // @ts-ignore
                showIf: function (formData) {
                    return showEpcBasedLimitationInfoSubtitle(formData, extraData);
                },
            }, _a[EField.LegallyAdjustedTotal] = {
                default: undefined,
            }, _a[EField.NewPrice] = {
                default: defaultValues[EEpcField.Label] || (extraData === null || extraData === void 0 ? void 0 : extraData.isCommercialLease)
                    ? defaultValues[EField.NewPrice] ||
                        getMaximumPrice({
                            formData: defaultValues,
                            extraData: extraData,
                        })
                    : undefined,
                // @ts-ignore
                showIf: function (formData) { return canIndex(formData, extraData); },
                minimum: 0,
                getMaximum: function (formData) {
                    return getMaximumPrice({
                        formData: formData,
                        extraData: extraData,
                    });
                },
            }, _a[EField.NewCommonCosts] = {
                default: (function () {
                    if (!defaultValues[EField.CurrentCommonCosts]) {
                        return;
                    }
                    var adjustedCost = calculatePartiallyIndexedCost({
                        currentPrice: defaultValues[EField.CurrentPrice],
                        userInput: getMaximumPrice({
                            formData: defaultValues,
                            extraData: extraData,
                        }),
                        currentCost: defaultValues[EField.CurrentCommonCosts],
                    });
                    return Number(adjustedCost.toFixed(2));
                })(),
                // @ts-ignore
                showIf: function () { return extraData.contract.commonCostsAreIndexable; },
                requiredIf: function () { return extraData.contract.commonCostsAreIndexable; },
                minimum: 0,
                handleChange: function (fieldName, fieldValue, myFieldValue, formData) {
                    if (fieldName === EField.NewPrice) {
                        var adjustedCost = calculatePartiallyIndexedCost({
                            currentPrice: formData[EField.CurrentPrice],
                            userInput: formData[EField.NewPrice],
                            currentCost: formData[EField.CurrentCommonCosts],
                        });
                        return {
                            shouldSetNewValue: true,
                            newValue: Number(adjustedCost.toFixed(2)),
                        };
                    }
                    return { shouldSetNewValue: false };
                },
            }, _a[EField.NewNonCommonCosts] = {
                default: (function () {
                    if (!defaultValues[EField.CurrentNonCommonCosts]) {
                        return;
                    }
                    var adjustedCost = calculatePartiallyIndexedCost({
                        currentPrice: defaultValues[EField.CurrentPrice],
                        userInput: getMaximumPrice({
                            formData: defaultValues,
                            extraData: extraData,
                        }),
                        currentCost: defaultValues[EField.CurrentNonCommonCosts],
                    });
                    return Number(adjustedCost.toFixed(2));
                })(),
                // @ts-ignore
                showIf: function () { return extraData.contract.nonCommonCostsAreIndexable; },
                requiredIf: function () { return extraData.contract.nonCommonCostsAreIndexable; },
                minimum: 0,
                handleChange: function (fieldName, fieldValue, myFieldValue, formData) {
                    if (fieldName === EField.NewPrice) {
                        var adjustedCost = calculatePartiallyIndexedCost({
                            currentPrice: formData[EField.CurrentPrice],
                            userInput: formData[EField.NewPrice],
                            currentCost: formData[EField.CurrentNonCommonCosts],
                        });
                        return {
                            shouldSetNewValue: true,
                            newValue: Number(adjustedCost.toFixed(2)),
                        };
                    }
                    return { shouldSetNewValue: false };
                },
            }, _a), getNewAdditionalCostFieldsSchema({ extraData: extraData, defaultValues: defaultValues })), (_b = {}, _b[EField.ActualTotal] = {
                default: getDefaultTotal(defaultValues, extraData),
                minimum: 0,
                // @ts-ignore
                handleChange: function (fieldName, fieldValue, myFieldValue, formData) {
                    if (fieldName === EField.NewPrice) {
                        var total = getActualTotal(formData, extraData);
                        return {
                            shouldSetNewValue: true,
                            newValue: total,
                        };
                    }
                    return { shouldSetNewValue: false };
                },
            }, _b[EField.Retroactivity] = {
                type: "boolean",
                default: getValue(EField.Retroactivity, initialValues, defaultValues),
                // @ts-ignore
                showIf: function (formData) {
                    return (canIndex(formData, extraData) &&
                        (extraData.indexInfo.retroactivityMonths || 0) > 0 &&
                        (extraData.indexInfo.increase || 0) > 0);
                },
            }, _b[EField.GenerateLetter] = {
                type: "boolean",
                default: getValue(EField.GenerateLetter, initialValues, defaultValues),
                // @ts-ignore
                showIf: function (formData) {
                    return extraData.showGenerateLetter && canIndex(formData, extraData);
                },
            }, _b[EField.LetterType] = {
                default: getValue(EField.LetterType, initialValues, defaultValues),
                // @ts-ignore
                options: (_c = extraData.letterTemplates) === null || _c === void 0 ? void 0 : _c.map(function (template) { return ({
                    id: template.id,
                    value: template.name,
                }); }),
                showIf: function (formData) {
                    return formData[EField.GenerateLetter] === true &&
                        canIndex(formData, extraData);
                },
            }, _b)),
        };
    };
};
export var uiSchema = function (extraData, initialValues) {
    var _a, _b;
    return __assign(__assign((_a = {}, _a[EField.NewPrice] = {
        "ui:field": ERentioFormField.Number,
        title: ts.contractIndexPriceNew(),
        suffixText: "EUR",
        isFloat: true,
        decimals: CONFIG.DECIMALS_FOR_CURRENCY,
        getInfo: function (formData) {
            var maxPrice = getMaximumPrice({
                formData: formData,
                extraData: extraData,
            });
            return ts.contractIndexPriceNewDescription({
                values: {
                    maximumPrice: formatCurrency(maxPrice),
                },
            });
        },
    }, _a[EField.CurrentPrice] = {
        "ui:field": ERentioFormField.Number,
        title: ts.contractIndexPriceCurrent(),
        suffixText: "EUR",
        isFloat: true,
        decimals: CONFIG.DECIMALS_FOR_CURRENCY,
        readOnly: true,
    }, _a[EField.NewCommonCosts] = {
        "ui:field": ERentioFormField.Number,
        title: ts.contractIndexCommonPriceNew(),
        suffixText: "EUR",
        isFloat: true,
        decimals: CONFIG.DECIMALS_FOR_CURRENCY,
        isDisabled: function () { return true; },
    }, _a[EField.NewNonCommonCosts] = {
        "ui:field": ERentioFormField.Number,
        title: ts.contractIndexNonCommonPriceNew(),
        suffixText: "EUR",
        isFloat: true,
        decimals: CONFIG.DECIMALS_FOR_CURRENCY,
        isDisabled: function () { return true; },
    }, _a), getNewAdditionalCostFieldsUiSchema({ contract: extraData.contract })), (_b = {}, _b[EField.ActualTotal] = {
        "ui:field": ERentioFormField.Number,
        title: ts.contractIndexTotalPriceActual(),
        suffixText: "EUR",
        isFloat: true,
        decimals: CONFIG.DECIMALS_FOR_CURRENCY,
        isDisabled: function () { return true; },
    }, _b[EField.EpcBasedLimitationInfo] = {
        "ui:field": ERentioFormField.HelpInfo,
        title: getLocalizedText("contract.index.epc_info.title"),
        getSubtitle: getEpcBasedLimitationInfoSubtitle(extraData),
        actionTitle: getLocalizedText("contract.index.epc_info.more_info.text"),
        onPressAction: function () {
            var url = getLocalizedText("contract.index.epc_info.more_info.link");
            window.open(url, "_blank");
        },
    }, _b[EField.LegallyAdjustedTotal] = {
        "ui:field": ERentioFormField.HelpInfo,
        title: getLocalizedText("contract.index.legally_adjusted_total.title"),
        getSubtitle: getLegalTotalInfoSubtitle(extraData, initialValues),
    }, _b[EField.Retroactivity] = {
        "ui:field": ERentioFormField.Switch,
        getLabel: function (formData) { return getAdjustedRetroactiveAmountLabel(extraData); },
    }, _b[EField.GenerateLetter] = {
        "ui:field": ERentioFormField.Switch,
        label: getLocalizedText("contract.index.generate_letter"),
    }, _b[EField.LetterType] = {
        "ui:field": ERentioFormField.DropdownSelect,
        label: getLocalizedText("contract.index.letter_type"),
    }, _b));
};
